export class Drehbereich {
  private _drehbereich: string;
  private _startWinkel: number;
  private _endWinkel: number;
  private _drehrichtung: number;
  private _drehrichtungBezeichnung: string;

  constructor(DrehbereichBezeichnung: string, Drehrichtung: number) {
    this._drehbereich = DrehbereichBezeichnung;
    this._drehrichtung = Drehrichtung;
    switch (this._drehrichtung) {
      case -1:
        this._drehrichtungBezeichnung = 'undefiniert';
        break;
      case 1:
        this._drehrichtungBezeichnung = 'vorne';
        break;
      case 2:
        this._drehrichtungBezeichnung = 'hinten';
        break;
      case 3:
        this._drehrichtungBezeichnung = 'recht';
        break;
      case 4:
        this._drehrichtungBezeichnung = 'links';
        break;
      case 0:
      default:
        this._drehrichtungBezeichnung = 'rundum';
        break;
    }
    this._startWinkel = parseFloat(this._drehbereich.split('-')[0].trim());
    if (this._startWinkel > 360) {
      this._startWinkel = this._startWinkel % 360;
    }
    this._endWinkel = parseFloat(this._drehbereich.split('-')[1].trim());
    if (this._endWinkel > 360) {
      this._endWinkel = this._endWinkel % 360;
    }
  }
  /**
   * prüft ob ein Winkel im Winkelbereich liegt.
   */
  enthaelt(testWinkel: number): boolean {
    if (testWinkel > 360) {
      testWinkel = testWinkel % 360;
    }
    if (this._startWinkel > this._endWinkel) {
      if ((testWinkel >= this._startWinkel && testWinkel <= 360) || (testWinkel <= this._endWinkel && testWinkel >= 0)) {
        return true;
      } else {
        return false;
      }
    } else if (this._startWinkel === this._endWinkel) {
      if (this._startWinkel === testWinkel) {
        return true;
      } else {
        return false;
      }
    } else {
      if (testWinkel >= this._startWinkel && testWinkel <= this._endWinkel) {
        return true;
      } else {
        return false;
      }
    }
  }
  holeDrehrichtung(): number {
    return this._drehrichtung;
  }
  holeDrehrichtungBezeichnung(): string {
    return this._drehrichtungBezeichnung;
  }
}
